import React from "react";

export const DollarIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}
            {...props}>
            {/* Vertical center line */}
            <path d="M12 2V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            {/* Dollar S-curve */}
            <path
                d="M17 6H9.5C8.57 6 7.68 6.37 7.02 7.02C6.37 7.68 6 8.57 6 9.5C6 10.43 6.37 11.32 7.02 11.98C7.68 12.63 8.57 13 9.5 13H14.5C15.43 13 16.32 13.37 16.98 14.02C17.63 14.68 18 15.57 18 16.5C18 17.43 17.63 18.32 16.98 18.98C16.32 19.63 15.43 20 14.5 20H6"
                stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
            />
        </svg>);
};